export default __webpack_public_path__ + "10f5d5a4997a86d6ca278a4e75d5612e.svg";